<template>
  <g>
    <circle
      id="d"
      v-if="active('d')"
      cx="742.5"
      cy="257.5"
      r="10"
      fill="#fff"
    /><circle
      id="di"
      v-if="active('di')"
      cx="791"
      cy="403"
      r="10"
      fill="#fff"
    /><circle
      id="ds"
      v-if="active('ds')"
      cx="597"
      cy="403"
      r="10"
      fill="#fff"
    /><circle
      id="dc"
      v-if="active('dc')"
      cx="597"
      cy="209"
      r="10"
      fill="#fff"
    /><circle
      id="i"
      v-if="active('i')"
      cx="742.5"
      cy="742.5"
      r="10"
      fill="#fff"
    /><circle
      id="id"
      v-if="active('id')"
      cx="791"
      cy="597"
      r="10"
      fill="#fff"
    /><circle
      id="is"
      v-if="active('is')"
      cx="597"
      cy="791"
      r="10"
      fill="#fff"
    />

    <circle
      id="ic"
      v-if="active('ic')"
      cx="597"
      cy="597"
      r="10"
      fill="#fff"
    />

    <circle
      id="s"
      v-if="active('s')"
      cx="257.5"
      cy="742.5"
      r="10"
      fill="#fff"
    /><circle
      id="sd"
      v-if="active('sd')"
      cx="403"
      cy="597"
      r="10"
      fill="#fff"
    /><circle
      id="si"
      v-if="active('si')"
      cx="403"
      cy="791"
      r="10"
      fill="#fff"
    /><circle
      id="sc"
      v-if="active('sc')"
      cx="209"
      cy="597"
      r="10"
      fill="#fff"
    /><circle
      id="c"
      v-if="active('c')"
      cx="257.5"
      cy="257.5"
      r="10"
      fill="#fff"
    /><circle
      id="cd"
      v-if="active('cd')"
      cx="403"
      cy="209"
      r="10"
      fill="#fff"
    /><circle
      id="ci"
      v-if="active('ci')"
      cx="403"
      cy="403"
      r="10"
      fill="#fff"
    /><circle
      id="cs"
      v-if="active('cs')"
      cx="209"
      cy="403"
      r="10"
      fill="#fff"
    />
  </g>
</template>

<script>
import { find } from 'lodash';

export default {
  props: {
    selectedWords: {
      type: Array,
      required: false,
      default: [],
    },
  },

  methods: {
    active(zone) {
      return find(this.selectedWords, function (word) {
        return word.zone.substr(0, 2) == zone;
      });
    },
  },
};
</script>